var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('error-layout',{attrs:{"code":"404","error":"Page does not exist","message":"Please, check that the URL is correct."}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }